var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8a959e",
    d: "M13.674 17.586a.79.79 0 0 1-.785.703H4.658a.79.79 0 0 1-.785-.703L2.546 5.649H15zM7.194 3.28a.79.79 0 0 1 .79-.79h1.58a.79.79 0 0 1 .79.79v.79h-3.16zm10.269.79h-5.53v-.79A2.373 2.373 0 0 0 9.563.91h-1.58a2.373 2.373 0 0 0-2.37 2.37v.79H.085v1.58h.873l1.345 12.11a2.367 2.367 0 0 0 2.356 2.108h8.231a2.367 2.367 0 0 0 2.355-2.108L16.59 5.65h.873z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8a959e",
    d: "M7.983 7.23h1.58v9.479h-1.58z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-85.241 12.33 11.96)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8a959e",
    d: "M7.574 11.172h9.517v1.58H7.574z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-4.759 5.22 11.975)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8a959e",
    d: "M4.43 7.216h1.581v9.517h-1.58z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.9b4822a1e5807de7478cd40dbc2854c2.svg";
export { ForwardRef as ReactComponent };